(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/company-details/company-details.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/company-details/company-details.js');
"use strict";

const _React = React,
  Fragment = _React.Fragment;
const PageWrapper = svs.ticket_partner.sharedComponents.pageWrapper.PageWrapper;
const InformationPanels = svs.ticket_partner.sharedComponents.informationPanels.InformationPanels;
const _svs$ticket_partner$c = svs.ticket_partner.companyDetails.components,
  CompanyDetailsForm = _svs$ticket_partner$c.CompanyDetailsForm,
  CompanyDetailsPasswordForm = _svs$ticket_partner$c.CompanyDetailsPasswordForm;
const GridRow = svs.ui.ReactGrid.GridRow;
const CompanyDetails = () => {
  var _svs$ticket_partner$d;
  return React.createElement(Fragment, null, React.createElement(PageWrapper, null, React.createElement(GridRow, {
    className: "u-flex-justify-content-center"
  }, React.createElement(CompanyDetailsForm, null)), React.createElement(GridRow, {
    className: "u-flex-justify-content-center"
  }, React.createElement(CompanyDetailsPasswordForm, null))), React.createElement(InformationPanels, {
    articles: (_svs$ticket_partner$d = svs.ticket_partner.data) === null || _svs$ticket_partner$d === void 0 || (_svs$ticket_partner$d = _svs$ticket_partner$d.articles) === null || _svs$ticket_partner$d === void 0 ? void 0 : _svs$ticket_partner$d.companyArticles
  }));
};
svs.ticket_partner.companyDetails.CompanyDetails = CompanyDetails;

 })(window);